import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import BeenhereIcon from '@material-ui/icons/Beenhere'
import {validarFacturaAction, obtenerFacturasPendientesAction } from "../../../ducks/facturacionRecienteDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
const ButtonAceptarFactura = (props) => {
    const { IdFactura } = props
    const dispatch = useDispatch()
    const handleClick = () => {
        dispatch(onLoadAnction({ message: ""}))
        dispatch(validarFacturaAction({ IdFactura: IdFactura })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status || Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response.status || Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            dispatch(obtenerFacturasPendientesAction())
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={handleClick} color="secondary" >
                <BeenhereIcon />
            </IconButton>
        </div>
    )
}
export default ButtonAceptarFactura